export const html = {
  set(html, _ref) {
    let view = _ref.view,
      elem = _ref.elem;
    view.$(elem).html(`${html}`);
  }
};